
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pasta",
      function () {
        return require("private-next-pages/pasta.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pasta"])
      });
    }
  